// Central map from a notification's type + data payload to its in-app
// destination. This is the single place that knows where a notification points,
// so adding a new notification type is a one-line change here rather than logic
// scattered across components. Used by the foreground hook and mirrored by the
// background service worker (which can't import this module).

export type NotificationData = Record<string, string>;

export function routeForNotification(
  type: string,
  data: NotificationData = {}
): string {
  switch (type) {
    case "new_message":
    case "new_offer":
      return "/my-messages";
    case "product_question":
      return data.productId
        ? `/product-details/${data.productId}`
        : "/my-listings";
    case "new_review":
      return data.businessId ? `/business/${data.businessId}` : "/my-profile";
    default:
      // Notifications are message-centric — fall back to the inbox.
      return "/my-messages";
  }
}
